export enum GeoLocation {
  latitude = 'CurrentGeoLocation.Latitude',
  longitude = 'CurrentGeoLocation.Longitude',
}
